<p-autoComplete
    [id]="id()"
    [optionValue]="'id'"
    [optionLabel]="showFullNameInSelection() ? 'label' : 'email'"
    [panelStyleClass]="id() + '-panel'"
    [appendTo]="'body'"
    [lazy]="true"
    [autoHighlight]="true"
    [completeOnFocus]="true"
    [forceSelection]="false"
    [disabled]="disabled()"
    [(ngModel)]="searchValue"
    [suggestions]="suggestions()"
    [showClear]="searchValue() !== ''"
    [placeholder]="'impersonate.selectUserPlaceholder' | translate"
    [minLength]="0"
    [styleClass]="'autocomplete-accounts'"
    (completeMethod)="getUserSuggestions()"
    (onKeyUp)="$event.keyCode === 13 ? getUserSuggestions() : valueChanged.emit(searchValue())"
    (onSelect)="selectAccount($event.value)"
    (onClear)="clearSelection()">
    <ng-template pTemplate="item" let-user>
        <div class="user-suggestion">
            <ellipsis-tooltip [id]="'user-suggestion-name'">
                <p class="name">{{ user.firstName || '' }} {{ user.lastName || '' }}</p>
            </ellipsis-tooltip>

            <ellipsis-tooltip [id]="'user-suggestion-email'">
                <p class="email">{{ user.email }}</p></ellipsis-tooltip
            >
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        @if (suggestions() && suggestions().length > 0) {
            <p class="autocomplete-footer">
                {{ 'impersonate.autocompleteFooter' | translate }}
            </p>
        }</ng-template
    ><ng-template pTemplate="empty">
        <p class="autocomplete-empty">
            {{ 'impersonate.autocompleteFooter' | translate }}
        </p>
    </ng-template>
</p-autoComplete>
